import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import { Tree } from 'primereact/tree';
import { AutoComplete } from 'primereact/autocomplete';
import { useState, useEffect } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { tree } from 'd3v4';
import '../styles/components/property-filter.scss'

export default function PropertyFilter({metadata, shownGenes, setShownGenes, attributeTypes}) {

    // calculate nodesbyproperties and allvalues, initialize selected values
    const nodesByProperties = {};
    const allValues = {};
    const intialSelectedValues = {};
    Object.keys(metadata).forEach(category => {
        nodesByProperties[category] = {};
        intialSelectedValues[category] = [];
        const catValues = new Set();
        Object.entries(metadata[category]).forEach(([strain, val]) => {
            if (!nodesByProperties[category][val]) {
                nodesByProperties[category][val] = new Set();
            }
            nodesByProperties[category][val].add(strain);
            catValues.add(val);
        });
        allValues[category] = [...catValues];
    });

    const [filteredValues, setFilteredValues] = useState([]);
    const [selectedValues, setSelectedValues] = useState(intialSelectedValues);
    const [expandedKeys, setExpandedKeys] = useState({});
    // force boxes to refresh
    const [version, setVersion] = useState(0);

    const search = (e, category) => {
        let newFilteredValues;
        if (!e.query.trim().length) {
            newFilteredValues = allValues[category];
        } else {
            newFilteredValues = allValues[category].filter(val => val.toLowerCase().startsWith(e.query.toLowerCase()));
        }
        setFilteredValues(newFilteredValues);
    }

    // create menu items
    const treeNodes = [];
    if (attributeTypes) {
        for (const type in attributeTypes) {
            treeNodes.push({
                key: `${type}-${version}`,
                label: type,
                children: []
            });
        }
        Object.keys(allValues).forEach((category, i) => {
            let foundCategory = false;
            for (const node of treeNodes) {
                if (attributeTypes[node.label] && attributeTypes[node.label][category]) {
                    node.children.push({
                        key: `${i}-${version}`,
                        label: category,
                        children: [
                            {
                                key: `${i}-box-${version}`,
                                label: 'Box',
                                data: {
                                    category: category
                                }
                            }
                        ]
                    });
                    foundCategory = true;
                    break;
                }
            }
            if (!foundCategory) treeNodes.push({
                key: `${i}-${version}`,
                label: category,
                children: [
                    {
                        key: `${i}-box-${version}`,
                        label: 'Box',
                        data: {
                            category: category
                        }
                    }
                ]
            })
        })
    } else {
        Object.keys(allValues).forEach((category, i) => {
            treeNodes.push({
                key: `${i}-${version}`,
                label: category,
                children: [
                    {
                        key: `${i}-box-${version}`,
                        label: 'Box',
                        data: {
                            category: category
                        }
                    }
                ]
            })
        })
    }

    const changeAndFilter = (e, node) => {
        const newSelectedValues = {
            ...selectedValues,
            [node.data.category]: e.value
        };
        // apply value filter - this happens when the selected values change
        let newShownGenes = null;

        Object.entries(newSelectedValues).forEach(([category, vals]) => {
            let categorySet = new Set();
                if (vals.length) {
                    vals.forEach(val => {
                        categorySet = new Set([...nodesByProperties[category][val], ...categorySet]);
                    })
                }
                if (categorySet.size) {
                    newShownGenes = newShownGenes ?
                        new Set([...newShownGenes].filter(gene => categorySet.has(gene))) :
                        categorySet;
                }
            setShownGenes(newShownGenes);
        });
        const newExpandedKeys = {};
        for (const key in expandedKeys) {
            newExpandedKeys[key.slice(0, -1) + (version + 1)] = true;
        }

        setExpandedKeys(newExpandedKeys);
        setSelectedValues(newSelectedValues);
        setVersion(version + 1);
    }
    
    const nodeTemplate = (node, options) => {
        if (node.children) return (
            <b>{node.label}</b>
        )
        else return (
            <div className='p-fluid flex justify-content-center'>
                <AutoComplete 
                    multiple
                    forceSelection
                    dropdown
                    value={selectedValues[node.data.category]}
                    suggestions={filteredValues}
                    completeMethod={e => search(e, node.data.category)}
                    onChange={e => changeAndFilter(e, node)}
                    pt={{
                        container:{
                            style: {
                                height: 'auto'
                            }
                        }
                    }}
                />
            </div>
            
        )
    }
    
    

    return (
        <Tree 
            value={treeNodes} 
            nodeTemplate={nodeTemplate} 
            expandedKeys={expandedKeys} 
            onToggle={e => setExpandedKeys(e.value)}
            pt={{
                subgroup: {className: 'branchclass'},
            }}
        />
    )
    
}